module.exports = __webpack_public_path__ + "static/media/2cent.b2383a25.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/coupures/2cent.png
// module id = 920
// module chunks = 0